import { render } from "./SubjectDialog.vue?vue&type=template&id=6fc18439"
import script from "./SubjectDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__